import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation UserEvaluation_create($userId: ID!, $lessonId: ID!, $grade: Int, $isDraft: Boolean) {
    UserEvaluation_create(userId: $userId, lessonId: $lessonId, grade: $grade, isDraft: $isDraft) {
      id
      grade
    }
  }
`;

const UserEvaluationCreate = async ({
  userId,
  lessonId,
  // scorerId,
  grade,
  isDraft,
}) =>
  graphql(mutation, {
    userId,
    lessonId,
    grade: parseInt(grade, 10),
    isDraft,
  }).then(
    // eslint-disable-next-line camelcase
    ({ UserEvaluation_create }) => UserEvaluation_create
  );

export default UserEvaluationCreate;
